import { __assign, __awaiter, __generator } from "tslib";
import { APP_DEFINITION_ID, TrackEventName } from '@wix/wixstores-client-core';
import { ONLINE_STORES_SPECS } from './constants';
import { removeUndefinedKeys } from '../../lib/removeUndefinedKeys';
import { mapToLineItem } from './addToCurrentCart/mapToLineItem';
import { createOnlineStoresBiLogger, reportAddToCartBI } from './bi.utils';
import { calculateAddToCartCartAction, handleAddToCartAction, preloadCartByAction } from './addToCart.utils';
import { CheckoutService } from './CheckoutService';
export function createViewerScript() {
    var _this = this;
    var context = {};
    return {
        initAppForPage: function (initParams, _apis, wixAPI, platformServices) {
            context.wixAPI = wixAPI;
            context.experiments = platformServices.essentials.experiments;
            context.errorHandler = platformServices.essentials.errorHandler;
            context.httpClient = platformServices.essentials.httpClient;
            context.initParams = initParams;
            context.checkoutService = new CheckoutService(context);
            if (context.experiments.enabled(ONLINE_STORES_SPECS.UseAddToCurrentCart)) {
                context.biLogger = createOnlineStoresBiLogger(wixAPI, platformServices);
            }
            context.trackEvent = wixAPI.window.trackEvent;
            return Promise.resolve();
        },
        createControllers: function () { return null; },
        exports: {
            cart: {
                addToCart: function (productId, quantity, options, preOrderRequested, trackData) { return __awaiter(_this, void 0, void 0, function () {
                    var ecomPlatformPublicAPI, hasCartIcon, addToCartAction, lineItem, ecomPlatformPublicAPI;
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                if (!context.experiments.enabled(ONLINE_STORES_SPECS.UseAddToCurrentCart)) return [3 /*break*/, 5];
                                return [4 /*yield*/, context.wixAPI.site.getPublicAPI(APP_DEFINITION_ID)];
                            case 1:
                                ecomPlatformPublicAPI = _b.sent();
                                return [4 /*yield*/, ecomPlatformPublicAPI.cart.hasCartIcon()];
                            case 2:
                                hasCartIcon = _b.sent();
                                addToCartAction = calculateAddToCartCartAction(options === null || options === void 0 ? void 0 : options.addToCartAction, hasCartIcon);
                                return [4 /*yield*/, mapToLineItem({
                                        productId: productId.toString(),
                                        quantity: Number(quantity),
                                        preOrderRequested: preOrderRequested,
                                        options: options !== null && options !== void 0 ? options : {},
                                    }, context)];
                            case 3:
                                lineItem = _b.sent();
                                return [4 /*yield*/, Promise.all([
                                        preloadCartByAction(ecomPlatformPublicAPI, addToCartAction),
                                        ecomPlatformPublicAPI.cart.addToCurrentCart({ lineItems: [lineItem] }),
                                    ])];
                            case 4:
                                _b.sent();
                                void trackAddToCartEvent(ecomPlatformPublicAPI, context, {
                                    productId: "".concat(productId),
                                    quantity: Number(quantity),
                                    variantId: options === null || options === void 0 ? void 0 : options.variantId,
                                    trackData: trackData,
                                });
                                reportAddToCartBI(context, {
                                    origin: 'addToCart',
                                    productId: "".concat(productId),
                                    quantity: Number(quantity),
                                    hasOptions: Object.keys((_a = options === null || options === void 0 ? void 0 : options.choices) !== null && _a !== void 0 ? _a : {}).length > 0,
                                    trackData: trackData,
                                });
                                return [2 /*return*/, handleAddToCartAction(ecomPlatformPublicAPI, addToCartAction, "".concat(productId))];
                            case 5: return [4 /*yield*/, context.wixAPI.site.getPublicAPI(APP_DEFINITION_ID)];
                            case 6:
                                ecomPlatformPublicAPI = _b.sent();
                                return [2 /*return*/, ecomPlatformPublicAPI.cart.addToCart(productId, quantity, options, preOrderRequested, trackData)];
                        }
                    });
                }); },
                addProducts: function (items, options) { return __awaiter(_this, void 0, void 0, function () {
                    var ecomPlatformPublicAPI, lineItems, shouldAddTrackData_1;
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, context.wixAPI.site.getPublicAPI(APP_DEFINITION_ID)];
                            case 1:
                                ecomPlatformPublicAPI = _a.sent();
                                if (!context.experiments.enabled(ONLINE_STORES_SPECS.UseAddToCurrentCart)) return [3 /*break*/, 4];
                                return [4 /*yield*/, Promise.all(items.map(function (item) { return __awaiter(_this, void 0, void 0, function () { var _a; return __generator(this, function (_b) {
                                        return [2 /*return*/, mapToLineItem(__assign(__assign({}, item), { productId: (_a = item.productId) !== null && _a !== void 0 ? _a : item.productID }), context)];
                                    }); }); }))];
                            case 2:
                                lineItems = _a.sent();
                                return [4 /*yield*/, ecomPlatformPublicAPI.cart.addToCurrentCart({ lineItems: lineItems })];
                            case 3:
                                _a.sent();
                                shouldAddTrackData_1 = context.experiments.enabled(ONLINE_STORES_SPECS.AddTrackDataOnAddProducts);
                                items.forEach(function (item) {
                                    var _a, _b, _c;
                                    trackAddToCartEvent(ecomPlatformPublicAPI, context, __assign({ productId: item.productId, quantity: item.quantity }, (shouldAddTrackData_1 ? { trackData: item.trackData, variantId: (_a = item.options) === null || _a === void 0 ? void 0 : _a.variantId } : {})));
                                    reportAddToCartBI(context, __assign({ origin: 'addProducts', productId: "".concat(item.productId), quantity: Number(item.quantity), hasOptions: Object.keys((_c = (_b = item.options) === null || _b === void 0 ? void 0 : _b.choices) !== null && _c !== void 0 ? _c : {}).length > 0 }, (shouldAddTrackData_1 ? { trackData: item.trackData } : {})));
                                });
                                return [3 /*break*/, 6];
                            case 4: return [4 /*yield*/, ecomPlatformPublicAPI.cart.addProducts(items, options)];
                            case 5:
                                _a.sent();
                                _a.label = 6;
                            case 6: return [2 /*return*/];
                        }
                    });
                }); },
            },
            checkout: {
                createCheckout: function (productId, quantity, options, preOrderRequested) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        return [2 /*return*/, context.checkoutService.createCheckout(productId, quantity, options, preOrderRequested)];
                    });
                }); },
            },
        },
    };
}
function trackAddToCartEvent(ecomPlatformPublicAPI, context, _a) {
    var _b, _c, _d;
    var productId = _a.productId, quantity = _a.quantity, variantId = _a.variantId, trackData = _a.trackData;
    return __awaiter(this, void 0, void 0, function () {
        var cart;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, ecomPlatformPublicAPI.cart.getCurrentCart()];
                case 1:
                    cart = _e.sent();
                    context.trackEvent(TrackEventName.ADD_TO_CART, removeUndefinedKeys({
                        cartId: (_b = cart.cartId) !== null && _b !== void 0 ? _b : undefined,
                        currency: (_d = (_c = cart.convertedCurrencyFormat) === null || _c === void 0 ? void 0 : _c.code) !== null && _d !== void 0 ? _d : undefined,
                        id: productId,
                        quantity: quantity,
                        name: trackData === null || trackData === void 0 ? void 0 : trackData.name,
                        sku: trackData === null || trackData === void 0 ? void 0 : trackData.sku,
                        price: trackData === null || trackData === void 0 ? void 0 : trackData.price,
                        type: trackData === null || trackData === void 0 ? void 0 : trackData.type,
                        category: trackData === null || trackData === void 0 ? void 0 : trackData.category,
                        variantId: variantId,
                    }));
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=viewerScript.js.map